import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonConstant } from 'src/app/common/utilities/common-constant';
import { LoadingComponent } from './loading/loading.component';

const routes: Routes = [
  {
    path: CommonConstant.Routes.Landing,
    component: LoadingComponent
  },
  {
    path: CommonConstant.Routes.Login,
    loadChildren: () => import('src/app/landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: CommonConstant.Routes.CustomerApproval,
    loadChildren: () => import('src/app/customer-approval/customer-approval.module').then(m => m.CustomerApprovalModule)
  },
  {
    path: CommonConstant.Routes.ConsentSuccess,
    loadChildren: () => import('src/app/verification-accounts/verification-accounts.module').then(m => m.VerificationAccountsModule)
  },
  {
    path: CommonConstant.Routes.LinkAccount,
    loadChildren: () => import('src/app/link-account/link-account.module').then(m => m.LinkAccountModule)
  },
  {
    path: CommonConstant.Routes.RouteNotFound,
    redirectTo: '',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
